import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import {
  loading,
  add,
  cancel,
  selectExperience,
  fetchExperiences,
  deleteExperience,
  experienceAdded,
  updateProgress,
  updateComplianceStatus,
  clearMam,
} from './actions';

import { Status } from './consts';

export const initialState = {
  loading: false,
  status: Status.EMPTY,
  experiences: [],
  selectedId: null,
  progress: 0,
};

const updateStatus = (currentState, selectedId = null) => {
  if (currentState.experiences.length) {
    return update(currentState, {
      status: { $set: Status.BROWSING },
      selectedId: { $set: selectedId || currentState.experiences[0]._id },
    });
  } else {
    return update(currentState, {
      status: { $set: Status.EMPTY },
      selectedId: { $set: null },
    });
  }
};

export const reducer = handleActions(
  {
    [loading]: {
      next: state =>
        update(state, {
          loading: { $set: true },
        }),
    },

    [add]: {
      next: state => {
        return update(state, {
          status: { $set: Status.ADDING },
          selectedId: { $set: null },
        });
      },
    },

    [cancel]: {
      next: state => updateStatus(state),
    },

    [fetchExperiences]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          loading: { $set: false },
          experiences: { $set: payload.docs || [] },
        });
        return updateStatus(newState);
      },
      throw: state => {
        const newState = update(state, {
          loading: { $set: false },
          experiences: { $set: [] },
        });
        return updateStatus(newState);
      },
    },

    [selectExperience]: {
      next: (state, { payload }) => {
        return update(state, {
          selectedId: { $set: payload._id },
        });
      },
    },

    [deleteExperience]: {
      next: (state, { payload }) => {
        const index = state.experiences.map(el => el._id).indexOf(payload._id);
        if (index >= 0) {
          const newState = update(state, {
            experiences: { $splice: [[index, 1]] },
          });
          return updateStatus(newState);
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [experienceAdded]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          experiences: { $push: [payload] },
          selectedId: { $set: payload._id },
        });
        return updateStatus(newState, payload._id);
      },
    },

    [updateProgress]: {
      next: (state, { payload }) => {
        if (payload > state.progress) {
          return update(state, {
            progress: { $set: payload === 100 ? 0 : payload },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          progress: { $set: 0 },
        });
      },
    },

    [updateComplianceStatus]: {
      next: (state, { payload }) => {
        let newState = cloneDeep(state);

        payload.rows.forEach(row => {
          // Get the experience index
          const index = state.experiences.map(el => el._id).indexOf(row._id);

          // Update the new state status and message content
          newState = update(newState, {
            loading: { $set: false },
            experiences: {
              [index]: {
                status: { $set: row.status },
                messages: { $set: row.messages },
              },
            },
          });
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [clearMam]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          loading: { $set: false },
          experiences: { $set: [] },
        });
        return updateStatus(newState);
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
